// import useDimensions from "react-use-dimensions";
import React, { useState, useEffect } from "react";
import { cstParseRows } from "cstree";
import { get } from "lodash";
import { connect } from "react-redux";
import SplitPane from "react-split-pane";
import BasicTree from '../components/BasicTree';
import InputPane from '../components/InputPane';
import Navigation from '../components/Navigation';
import { EDITOR_PANE_FRACTION } from '../constants';
import { getEditorValue, getLayoutType } from '../store/reducers';
import { setEditorValue } from '../store/actions';

import queryString from 'query-string';

const HEADERS = "name,crosslinks,url";
const SOURCE_PARAM_NAME = 'graphData';


const App = (props) => {
    // ComponentDidMount
    useEffect(() => {
      const params = queryString.parse(props.location.search);
      const graphDataUrl = params[SOURCE_PARAM_NAME];

      if (graphDataUrl) {
        // TODO: move data fetching into redux-observable or into a redux thunk so we can load samples more easily
        fetch(graphDataUrl).then((response) => {
          return response.text().then((text) => {
            props.setEditorValue(text.trim()); // cut whitespace
          })
        }
        )
      }


    }, []); // only run once since empty list values will never change.


    const defaultEditorWidth = window.innerWidth * EDITOR_PANE_FRACTION; // sizing based on vega-lite sizing
    const rows = cstParseRows(
      `${HEADERS}\n${props.editorValue}`,
      ([name, crosslinks, url]) => ({ name, crosslinks, url })
    );
    const parsedData = get(rows, 'children[1]', {});

    const pageWidth = window.innerWidth;
    // const [inputPaneRef, inputPaneDims] = useDimensions();
    const [ storedWidth, setWidth ] = useState(pageWidth - defaultEditorWidth);

    return (
      <div>
      <Navigation/>
      <SplitPane
        split="vertical"
        minSize={250}
        defaultSize={defaultEditorWidth}
        primary="first"
        onChange={size => setWidth(pageWidth - size)}
      >
        <InputPane />
        <div>
          <BasicTree
            x={90}
            y={window.innerHeight / 2}
            width={storedWidth}
            height={window.innerHeight}
            hierarchyData={parsedData}
            layoutType={props.layoutType}
          />
        </div>
      </SplitPane>
      </div>
    );
}

const mapStateToProps = (state) => ({
  editorValue: getEditorValue(state),
  layoutType: getLayoutType(state),
})

export default connect(
  mapStateToProps,
  {
    setEditorValue
  }
)(App);
